export const topologyList = [
  "Bouvet Island",
  "Botswana",
  "Belarus",
  "Belize",
  "Iran",
  "Italy",
  "Jersey",
  "Jamaica",
  "Jordan",
  "Japan",
  "Kenya",
  "Kyrgyzstan",
  "Cambodia",
  "Australia",
  "Aruba",
  "Azerbaijan",
  "Bosnia and Herzegovina",
  "Barbados",
  "Bangladesh",
  "Belgium",
  "Burkina Faso",
  "Bulgaria",
  "Bahrain",
  "Burundi",
  "Benin",
  "Saint Barthélemy",
  "Bermuda",
  "Brunei",
  "Bolivia",
  "Chile",
  "Cameroon",
  "China",
  "Taiwan",
  "Colombia",
  "Clipperton Island",
  "Costa Rica",
  "Cuba",
  "Cape Verde",
  "Andorra",
  "United Arab Emirates",
  "Afghanistan",
  "Antigua and Barbuda",
  "Anguilla",
  "Albania",
  "Armenia",
  "Angola",
  "Argentina",
  "American Samoa",
  "Austria",
  "Bonaire, Sint Eustatius and Saba",
  "Brazil",
  "Bahamas",
  "Bhutan",
  "Comoros",
  "Saint Kitts and Nevis",
  "North Korea",
  "Curaçao",
  "Christmas Island",
  "Cyprus",
  "Czechia",
  "Germany",
  "Djibouti",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "Algeria",
  "Ecuador",
  "Estonia",
  "Egypt",
  "Western Sahara",
  "Greece",
  "Eritrea",
  "Spain",
  "Ethiopia",
  "Finland",
  "Fiji",
  "Falkland Islands",
  "Micronesia",
  "Faroes",
  "France",
  "Gabon",
  "Grenada",
  "Georgia",
  "Guernsey",
  "Ghana",
  "Gibraltar",
  "Greenland",
  "Gambia",
  "Guinea",
  "Equatorial Guinea",
  "South Georgia and The South Sandwich Islands",
  "Guatemala",
  "Guam",
  "Guinea-Bissau",
  "Guyana",
  "Hong Kong",
  "Heard Island and Mcdonald Islands",
  "Honduras",
  "Croatia",
  "Haiti",
  "Hungary",
  "Ireland",
  "Israel",
  "Isle of Man",
  "India",
  "British Indian Ocean Territory",
  "Iraq",
  "New Zealand",
  "Oman",
  "Panama",
  "Peru",
  "Papua New Guinea",
  "Indonesia",
  "Iceland",
  "Cocos (Keeling) Islands",
  "Canada",
  "Democratic Republic of The Congo",
  "Central African Republic",
  "Congo",
  "Switzerland",
  "Ivory Coast",
  "Cook Islands",
  "Saudi Arabia",
  "Russian Federation",
  "Solomon Islands",
  "Seychelles",
  "Sudan",
  "Sweden",
  "Singapore",
  "Saint Helena, Ascension and Tristan Da Cunha",
  "Slovenia",
  "Madagascar",
  "Marshall Islands",
  "North Macedonia",
  "Mali",
  "Myanmar/Burma",
  "Mongolia",
  "Macau",
  "Northern Mariana Islands",
  "Mauritania",
  "Montserrat",
  "Malta",
  "Mauritius",
  "Maldives",
  "Malawi",
  "Mexico",
  "Malaysia",
  "Mozambique",
  "Namibia",
  "New Caledonia",
  "Niger",
  "Norfolk Island",
  "Nigeria",
  "Nicaragua",
  "Netherlands",
  "Norway",
  "Nepal",
  "Nauru",
  "Niue",
  "Slovakia",
  "Sierra Leone",
  "San Marino",
  "Senegal",
  "Somalia",
  "Suriname",
  "South Sudan",
  "São Tomé and Príncipe",
  "El Salvador",
  "Sint-Maarten",
  "Syria",
  "Eswatini",
  "Turks and Caicos Islands",
  "Chad",
  "French Southern and Antarctic Lands",
  "Togo",
  "Thailand",
  "Tajikistan",
  "Tokelau",
  "Timor-Leste",
  "Turkmenistan",
  "Tunisia",
  "Tonga",
  "South Korea",
  "Kuwait",
  "Cayman Islands",
  "Kazakhstan",
  "Laos",
  "Lebanon",
  "Saint Lucia",
  "Liechtenstein",
  "Sri Lanka",
  "Liberia",
  "Lesotho",
  "Lithuania",
  "Luxembourg",
  "Latvia",
  "Libya",
  "Morocco",
  "Monaco",
  "Moldova",
  "Montenegro",
  "Philippines",
  "Pakistan",
  "Poland",
  "Saint Pierre and Miquelon",
  "Pitcairn Islands",
  "Puerto Rico",
  "Palestine",
  "Portugal",
  "Palau",
  "Paraguay",
  "Qatar",
  "Romania",
  "Serbia",
  "Rwanda",
  "Kuril Islands",
  "Navassa Island",
  "Scarborough Reef",
  "Senkaku Islands",
  "Bassas Da India",
  "Abyei",
  "Bir Tawil (Disputed Territory)",
  "Yemen",
  "South Africa",
  "Zambia",
  "Zimbabwe",
  "French Polynesia",
  "Kiribati",
  "Türkiye",
  "Trinidad and Tobago",
  "Tuvalu",
  "United Republic of Tanzania",
  "Ukraine",
  "Uganda",
  "United Kingdom",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vatican City",
  "Saint Vincent and The Grenadines",
  "Venezuela",
  "British Virgin Islands",
  "Us Virgin Islands",
  "Vietnam",
  "Vanuatu",
  "Wallis and Futuna",
  "United States",
  "Samoa",
  "Paracel Islands",
  "Spratly Islands",
  "Aksai Chin",
  "Arunachal Pradesh",
  "China/India",
  "Hala'Ib Triangle",
  "Ilemi Triangle",
  "Jammu Kashmir",
];
